export default __webpack_public_path__ + "static/media/solarlight.5a4c846b.png";